module.exports = __webpack_public_path__ + "img/xiansuling.e27a74d8.png";